//  export storage keys
export const STORAGE_KEYS = {
  SELECTED_LANGUAGE: "selected_language",
};
